/* eslint-disable react/prop-types */
import { ToTopOutlined } from "@ant-design/icons";
import { Fab } from "@mui/material";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";

const GoTop = (props) => {
  const [showGoTop, setShowGoTop] = useState(false);

  const handleVisibleButton = () => {
    setShowGoTop(window.pageYOffset > 50);
  };

  const handleScrollUp = () => {
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleVisibleButton);
    return () => window.removeEventListener("scroll", handleVisibleButton);
  }, []);

  return (
    <>
      {showGoTop ? (
        <Tooltip title="Back to Top">
          <Fab
            onClick={handleScrollUp}
            size="medium"
            color="success"
            aria-label="top"
          >
            <ToTopOutlined />
          </Fab>
        </Tooltip>
      ) : null}
    </>
  );
};
export default GoTop;
